import { Chess } from 'chess.js';

import { applyNullMove } from './applyNullMove';
import { FEN_STARTING_POSITION } from './constants';
import { IPgnMove } from './pgn';
import { SquareName } from './types';

export type MovesToFenResult = {
  fen: string;
  from?: SquareName;
  to?: SquareName;
  winner?: 'draw' | 'white' | 'black';
  error?: {
    message: string;
    move: IPgnMove;
  };
};

export function movesToFen(
  initialFen: string = FEN_STARTING_POSITION,
  moves: IPgnMove[] = [],
): MovesToFenResult {
  const chess = new Chess(initialFen, {
    enable960: true,
    skipValidation: true,
  });

  let error: undefined | MovesToFenResult['error'];

  for (let i = 0; i < moves.length; i++) {
    const m = moves[i]!;
    try {
      if (m.san === '--') {
        applyNullMove(chess);
      } else {
        chess.move(m.san);
      }
    } catch (e) {
      error = { message: e instanceof Error ? e.message : 'Неизвестная ошибка хода', move: m };
      break;
    }
  }
  const h = chess.history({ verbose: true });
  const m = h[h.length - 1];
  const { from, to } = m ?? {};
  const fen = chess.fen();
  const winner = mapWinner(chess);
  return { fen, from, to, winner, error };
}

export function mapWinner(chess: Chess): MovesToFenResult['winner'] {
  if (!chess.isGameOver()) return undefined;
  if (chess.isDraw()) return 'draw';
  return chess.turn() === 'b' ? 'white' : 'black';
}
